import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Chip, Paper, Typography } from "@mui/material";
import { CompareArrows } from "@mui/icons-material";
import useNegotiationAlerts from "../hooks/useNegotiationAlerts";
import { formatTimeLeft } from "../config/negotiation-utils";

const MAX_ROWS = 5;

const KIND_LABEL = {
  OFFER: "New offer",
  EXPIRED: "Offer expired — you can counter",
  PROPOSAL: "Settlement proposal",
  BLIND: "Your confidential bid",
};

// Negotiations waiting on the signed-in party. Renders nothing when there are none.
export default function AwaitingWidget() {
  const { data: user } = useSelector((state) => state.user);
  const { count, items } = useNegotiationAlerts(user?.token, "dashboard");
  if (!count) return null;

  return (
    <Paper className="odr-card mt-4">
      <Box className="odr-card-header flex flex-wrap items-center justify-between gap-2">
        <Box className="flex items-center gap-2">
          <CompareArrows className="text-brand" />
          <Typography className="heading-title">Awaiting your response</Typography>
          <Chip size="small" label={count} className="!bg-[#fff4e0] !text-[#b45309] !font-semibold" />
        </Box>
        <Link to="/negotiation" className="text-[13px] font-semibold !text-brand">
          View all
        </Link>
      </Box>
      <Box className="px-4 pb-4">
        <ul className="m-0 p-0 list-none">
          {items.slice(0, MAX_ROWS).map((n) => (
            <li
              key={`${n.negotiationId}-${n.kind}`}
              className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2.5 border-b border-solid border-b-[#e6eaf2] last:border-b-0"
            >
              <Box className="min-w-0">
                <Typography className="text-[14px] font-semibold text-[#0d1b36] truncate">{n.title}</Typography>
                <Link to={`/negotiation/${n.caseId}/${n.negotiationId}`} className="text-[12px] text-[#6b7a90] hover:underline">
                  {n.caseTitle}
                </Link>
              </Box>
              <Box className="flex items-center gap-2">
                {typeof n.secondsLeft === "number" && n.secondsLeft > 0 ? (
                  <span className="text-xs text-[#666]">{formatTimeLeft(n.secondsLeft)} left</span>
                ) : null}
                <Chip size="small" label={KIND_LABEL[n.kind] || n.kind} className="!bg-[#fff4e0] !text-[#b45309]" />
              </Box>
            </li>
          ))}
        </ul>
        {count > MAX_ROWS ? (
          <Typography className="pt-2 text-center text-[12px] text-[#6b7a90]">
            + {count - MAX_ROWS} more on the Negotiations page
          </Typography>
        ) : null}
      </Box>
    </Paper>
  );
}
